import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AppLinkBuilder} from '../../../utils';
import {IconType, PtEntity} from '@pt/pt-models';

@Component({
  selector: 'pt-editor-list-card',
  templateUrl: './editor-list-card.component.html',
  styleUrls: ['./editor-list-card.component.scss']
})
export class EditorListCardComponent {
  @Input() title: string;
  @Input() entity: PtEntity;
  @Input() entities: DetailsListCardItem[];

  @Input() noDataMessage?: string;
  @Input() showNoData = false;
  @Input() showWarning = false;
  @Input() warningMessage?: string;
  @Input() showInfo = false;
  @Input() infoMessage?: string;
  @Output() clickOpen = new EventEmitter();

  SVG = IconType.SVG;

  openDetails(item: DetailsListCardItem) {
    window.open(AppLinkBuilder.linkOfEntity(this.entity, item.id), '_blank');
  }
}

export interface DetailsListCardItem {
  name: string;
  id: number;
}
